import { useState } from 'react';

interface FaqAccordionProps {
  faqs: Array<{ question: string; answer: string }>;
}

export default function FaqAccordion({ faqs }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="space-y-4">
      {faqs.map((faq, index) => {
        const panelId = `faq-panel-${index}`;
        const btnId = `faq-btn-${index}`;
        const isOpen = openIndex === index;
        return (
          <div
            key={index}
            className="bg-white rounded-2xl border border-[#E8E2D6] overflow-hidden hover:shadow-lg transition-shadow"
          >
            <button
              id={btnId}
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              aria-controls={panelId}
              className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 hover:bg-[#F7F5F0] transition-colors"
            >
              <span className="font-['Oswald'] text-lg font-bold text-[#1C2B1E] flex-1">
                {faq.question}
              </span>
              <div
                className={`w-11 h-11 flex items-center justify-center rounded-full bg-[#E8B84B] text-[#1C2B1E] flex-shrink-0 transition-transform ${
                  isOpen ? 'rotate-180' : ''
                }`}
                aria-hidden="true"
              >
                <i className="ri-arrow-down-s-line text-xl"></i>
              </div>
            </button>

            {isOpen && (
              <div
                id={panelId}
                role="region"
                aria-labelledby={btnId}
                className="px-6 pb-6 pt-2"
              >
                <div className="prose prose-sm max-w-none text-[#374151] leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
